import { Directive } from "@angular/core";

@Directive({
    selector: '[t4ListItemExpand]',
    standalone: false
})
  export class ListItemExpandDirective {}
